import { createElement, CSSProperties, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useDesignTokens, useGlobalDesignTokens } from '../../../theme';
import { getDndStyleTokens } from '../../../style/reactDnd/DndStyleTokens';
import { getDragPreviewRoot } from '.';
import { useReactDndConstructs } from '../../../dnd/ReactDndContext';
import { XYCoord } from 'react-dnd';
import cx from 'classnames';
import cn from './DragPreview.css.json';
import './DragPreview.css';

export interface DragPreviewProps {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
}

function getDraggingStyles(currentOffset: XYCoord | null) {
  if (!currentOffset) {
    return {
      display: 'none',
    };
  }

  const transform = `translate(${currentOffset.x}px, ${currentOffset.y}px)`;
  return {
    transform,
  };
}

export const DragPreview = (props: DragPreviewProps) => {
  const dt = useDesignTokens();
  const globalDesignTokens = useGlobalDesignTokens();
  const { useDragLayer } = useReactDndConstructs();

  const { isDragging, currentOffset } = useDragLayer((monitor) => ({
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getSourceClientOffset(),
  }));

  if (!isDragging) return null;

  return createPortal(
    <div
      className={cx(cn.dragImagePreview, props.className)}
      style={{
        ...getDraggingStyles(currentOffset),
        ...getDndStyleTokens(dt),
        ...globalDesignTokens,
        ...props.style,
      }}
    >
      {props.children}
    </div>,
    getDragPreviewRoot()
  );
};
